export const currencyCodesMinorUnitsExceptions: { [key: string]: number } = {
  BHD: 3,
  BIF: 0,
  BYR: 0,
  CLF: 0,
  CLP: 0,
  CVE: 0,
  DJF: 0,
  GNF: 0,
  IDR: 0,
  IQD: 0,
  IRR: 0,
  ISK: 0,
  JOD: 3,
  JPY: 0,
  KMF: 0,
  KPW: 0,
  KRW: 0,
  KWD: 0,
  LAK: 0,
  LBP: 0,
  LYD: 3,
  MGA: 1,
  MOP: 1,
  MRO: 1,
  OMR: 3,
  PYG: 0,
  RWF: 0,
  SLL: 0,
  STD: 0,
  TND: 3,
  UYI: 0,
  VND: 0,
  VUV: 0,
  XAF: 0,
  XOF: 0,
  XPF: 0,
} as const;

export const getCurrencyMinorUnits = (currency: string): number => {
  const TWO_DECIMALS = 2;
  const exceptions = currencyCodesMinorUnitsExceptions[currency];
  return exceptions === undefined ? TWO_DECIMALS : exceptions;
};

export const getCurrencyInputStep = (currency?: string): string => {
  if (!currency) {
    return '0.01';
  }

  const steps: { [key: number]: string } = {
    0: '1',
    1: '0.1',
    2: '0.01',
    3: '0.001',
  } as const;
  return steps[getCurrencyMinorUnits(currency)];
};

export const CURRENCY_CODES = [
  'AED',
  'AFN',
  'ALL',
  'AMD',
  'ANG',
  'AOA',
  'ARS',
  'AUD',
  'AWG',
  'AZN',
  'BAM',
  'BBD',
  'BDT',
  'BGN',
  'BHD',
  'BIF',
  'BMD',
  'BND',
  'BOB',
  'BRL',
  'BSD',
  'BTN',
  'BWP',
  'BYN',
  'BZD',
  'CAD',
  'CDF',
  'CHF',
  'CLP',
  'CNY',
  'COP',
  'CRC',
  'CUC',
  'CUP',
  'CVE',
  'CZK',
  'DJF',
  'DKK',
  'DOP',
  'DZD',
  'EGP',
  'ERN',
  'ETB',
  'EUR',
  'FJD',
  'FKP',
  'GBP',
  'GEL',
  'GHS',
  'GIP',
  'GMD',
  'GNF',
  'GTQ',
  'GYD',
  'HKD',
  'HNL',
  'HRK',
  'HTG',
  'HUF',
  'IDR',
  'ILS',
  'INR',
  'IQD',
  'IRR',
  'ISK',
  'JMD',
  'JOD',
  'JPY',
  'KES',
  'KGS',
  'KHR',
  'KMF',
  'KPW',
  'KRW',
  'KWD',
  'KYD',
  'KZT',
  'LAK',
  'LBP',
  'LKR',
  'LRD',
  'LSL',
  'LYD',
  'MAD',
  'MDL',
  'MGA',
  'MKD',
  'MMK',
  'MNT',
  'MOP',
  'MRU',
  'MUR',
  'MVR',
  'MWK',
  'MXN',
  'MYR',
  'MZN',
  'NAD',
  'NGN',
  'NIO',
  'NOK',
  'NPR',
  'NZD',
  'OMR',
  'PAB',
  'PEN',
  'PGK',
  'PHP',
  'PKR',
  'PLN',
  'PYG',
  'QAR',
  'RON',
  'RSD',
  'RUB',
  'RWF',
  'SAR',
  'SBD',
  'SCR',
  'SDG',
  'SEK',
  'SGD',
  'SHP',
  'SLL',
  'SOS',
  'SRD',
  'SSP',
  'STN',
  'SVC',
  'SYP',
  'SZL',
  'THB',
  'TJS',
  'TMT',
  'TND',
  'TOP',
  'TRY',
  'TTD',
  'TWD',
  'TZS',
  'UAH',
  'UGX',
  'USD',
  'UYU',
  'UZS',
  'VES',
  'VND',
  'VUV',
  'WST',
  'XAF',
  'XCD',
  'XOF',
  'XPF',
  'YER',
  'ZAR',
  'ZMW',
  'ZWL',
];

export const CURRENCIES = CURRENCY_CODES.reduce(
  (accumulator, code) => {
    try {
      const formatter = new Intl.NumberFormat('en', {
        style: 'currency',
        currency: code,
        currencyDisplay: 'symbol',
      });

      const name = new Intl.DisplayNames(['en'], { type: 'currency' }).of(code);
      const symbol = formatter
        // eslint-disable-next-line no-magic-numbers
        .formatToParts(0)
        .find((part) => part.type === 'currency')?.value;

      accumulator[code] = {
        code,
        label: name || code,
        symbol: symbol || code,
      };
    } catch (error) {
      console.warn(`Could not format currency ${code}:`, error);
    }
    return accumulator;
  },
  {} as Record<string, { code: string; label: string; symbol: string }>,
);
